import * as React from 'react';
import { useIntl } from 'react-intl';
import { styled } from 'stitches.config';

// AMF-mandated disclaimer (DOC-2017-07) for simulators that project investment
// performance. Typography matches the Figma design system tokens body/md/accent
// (14px / weight 500) on the neutral/bolder color so the warning reads as
// non-muted relative to other gray copy without being pure white.
//
// Layout (max-width, padding, card chrome) is intentionally left to the caller
// since each simulator places this block differently — embedded inside the
// Life Step 3 card stack, or standalone below the Wealth/Compound graph.
export const ComplianceDisclaimer: React.FC<{ className?: string }> = ({ className }) => {
  const { formatMessage } = useIntl();
  return (
    <Text className={className}>
      {formatMessage({ id: 'simulators.compliance_disclaimer' })}
    </Text>
  );
};

const Text = styled('p', {
  margin: 0,
  fontFamily: '$montreal',
  fontSize: '14px',
  lineHeight: '20px',
  fontWeight: '$medium',
  color: '$webappSecondary',
  textAlign: 'left',
});
